export const TARGET_TYPES = {
  MainTarget: 'Main Target',
  ProductTarget: 'Product Target',
  MonthlyTargetLayered: 'Monthly Target - Layered',
  ProductTargetLayered: 'Product Target - Layered',
  MonthlyTargetPrerequistite: 'Monthly Target - Prerequisite',
  ProductTargetPrerequisite: 'Product Target - Prerequisite',
  EarlyPaymentTarget: 'Early Payment Target',
  DropSizeTarget: 'Drop Size Target'
};

export const TARGET_TYPES_OPTIONS = {
  'Main Target': TARGET_TYPES.MainTarget,
  'Product Target': TARGET_TYPES.ProductTarget,
  'Monthly Layered Target': TARGET_TYPES.MonthlyTargetLayered,
  'Product Layered Target': TARGET_TYPES.ProductTargetLayered,
  'Monthly Prerequisite Target': TARGET_TYPES.MonthlyTargetPrerequistite,
  'Product Prerequisite Target': TARGET_TYPES.ProductTargetPrerequisite,
  'Early Payments Points': TARGET_TYPES.EarlyPaymentTarget,
  'Drop Size Booster Points': TARGET_TYPES.DropSizeTarget
};

export const EARLY_PAYMENT_TYPES = [
  'EARLY_PAYMENT_SALES_TARGET',
  'Early Payments Points'
];
export const DROP_SIZE_TYPES = ['BOOSTER_TARGET', 'Drop Size Booster Points'];

export const IMAGETYPE = {
  Foreground: 'foreground-image',
  Background: 'background-image'
};

export const BOOLEAN_VALUES = {
  TRUE: true,
  FALSE: false
};

export const DISPLAY_CONTENT_VARIANT = {
  EARLY_PAYMENT: 'earlyPayment',
  MAIN: 'main',
  LAYERED: 'layered'
};
